var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13964 1.08166C8.5267 0.426531 9.47458 0.42656 9.8616 1.08172L17.1924 13.4914C17.5862 14.158 17.1056 15 16.3314 15H1.66882C0.894551 15 0.414013 14.1579 0.807858 13.4913L8.13964 1.08166ZM8.00001 4.49999C8.00001 4.22385 8.22386 3.99999 8.50001 3.99999H9.50001C9.77615 3.99999 10 4.22385 10 4.49999V9C10 9.55228 9.55229 10 9.00001 10C8.44772 10 8.00001 9.55228 8.00001 9V4.49999ZM9.00001 11C8.44772 11 8.00001 11.4477 8.00001 12C8.00001 12.5523 8.44772 13 9.00001 13C9.55229 13 10 12.5523 10 12C10 11.4477 9.55229 11 9.00001 11Z",
    fill: "#EA891E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2fd5fb789347add93934c13473f8ec5f.svg";
export { ForwardRef as ReactComponent };